/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;background-color:#e0e0e0;height:100%}button[_ngcontent-%COMP%]{margin:5px}button[_ngcontent-%COMP%]   md-icon[_ngcontent-%COMP%]{margin-right:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/navmenu/navmenu.component.css.shim.ngstyle.js.pre-build-optimizer.js